export default __webpack_public_path__ + "static/media/Spiderman2_21.bacf611b.png";